import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { Model } from 'core/model/Model';
import { computed } from 'mobx';
import { getLabelTypeValue } from '@kentik/ui-shared/labels/lib';
import $assetTags from 'app/stores/assetTags/$assetTags';
let AssetTagValueMappingModel = (_class = class AssetTagValueMappingModel extends Model {
  /**
   * Overrides sort values to ensure we sort by options values and by lowercase
   * so we don't get uppercase bunched at the top.
   */
  getSortValue(field) {
    if (field === 'asset_type') {
      return getLabelTypeValue(this.get('asset_type'));
    }
    if (field === 'name') {
      return this.name?.toLowerCase() || '';
    }
    return super.getSortValue(field);
  }

  /**
   * Leverages an asset type's own collection to get their name.
   * Used for providing a name in the mapping table.
   */
  get name() {
    return $assetTags.getAssetName({
      assetType: this.get('asset_type'),
      assetId: this.get('asset_id')
    });
  }
}, _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _class);
export { AssetTagValueMappingModel as default };